var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1722215794471,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1489,
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.506 482.153h409.367V72.787H70.506v409.366z m66.328-343.038h276.71v276.71h-276.71v-276.71z",
    "p-id": 1490,
    fill: "#5E6570"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M199.721 202.002h150.937v150.937H199.721zM803.927 550.897H551.628v155.787h408.086V550.897H807.038zM803.927 786.376h155.787v155.787H803.927zM551.628 786.376h155.787v155.787H551.628zM550.988 78.483V487.85h409.367V78.483H550.988z m343.038 343.038h-276.71v-276.71h276.71v276.71z",
    "p-id": 1491,
    fill: "#5E6570"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M680.203 207.697H831.14v150.937H680.203zM63.645 951.213h409.367V541.847H63.645v409.366z m66.329-343.037h276.71v276.709h-276.71V608.176z",
    "p-id": 1492,
    fill: "#5E6570"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M192.86 671.062h150.937v150.937H192.86z",
    "p-id": 1493,
    fill: "#5E6570"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.1ea5cec5e283bd8e02a81773568e0696.svg";
export { ForwardRef as ReactComponent };